var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.38779 28H6.52288C6.06589 28 5.62762 27.8314 5.30448 27.5314C4.98134 27.2313 4.7998 26.8243 4.7998 26.4V5.6C4.7998 5.17565 4.98134 4.76869 5.30448 4.46863C5.62762 4.16857 6.06589 4 6.52288 4H18.7326C18.9589 3.9999 19.183 4.04121 19.3922 4.12156C19.6013 4.2019 19.7913 4.31972 19.9514 4.46827L26.6955 10.7317C27.0183 11.0317 27.1997 11.4384 27.1998 11.8624V16.8",
    stroke: "#040506",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3999 12H19.9999C19.5756 12 19.1686 11.8314 18.8685 11.5314C18.5685 11.2313 18.3999 10.8243 18.3999 10.4V4",
    stroke: "#040506",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5928 28C11.4707 28 12.3127 27.6728 12.9335 27.0903C13.5544 26.5078 13.9031 25.7178 13.9031 24.8941V23.3412C13.9031 22.5174 13.5544 21.7274 12.9335 21.145C12.3127 20.5625 11.4707 20.2353 10.5928 20.2353V28Z",
    stroke: "#040506",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8964 20.2352C18.4574 20.2352 18.0364 20.3988 17.726 20.69C17.4156 20.9812 17.2412 21.3762 17.2412 21.7881V26.4469C17.2412 26.8588 17.4156 27.2538 17.726 27.545C18.0364 27.8363 18.4574 27.9999 18.8964 27.9999C19.3354 27.9999 19.7564 27.8363 20.0668 27.545C20.3772 27.2538 20.5516 26.8588 20.5516 26.4469V21.7881C20.5516 21.3762 20.3772 20.9812 20.0668 20.69C19.7564 20.3988 19.3354 20.2352 18.8964 20.2352Z",
    stroke: "#040506",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2 20.2352C26.322 20.2352 25.48 20.5624 24.8592 21.1449C24.2384 21.7273 23.8896 22.5173 23.8896 23.341V24.894C23.8896 25.7177 24.2384 26.5077 24.8592 27.0902C25.48 27.6726 26.322 27.9999 27.2 27.9999",
    stroke: "#040506",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.670d5597f6e476fd54a7d274504948a7.svg";
export { ForwardRef as ReactComponent };